export default __webpack_public_path__ + "static/media/sucess.1b6082f8.svg";